import { getTotalForestArea } from "./utils";

const calculateDiscountAmount = (couponDiscount) =>
  couponDiscount?.coupon_discount_price || 0;

export const calculatePrices = ({
  properties,
  couponDiscount,
  hasDfr
}) => {
  const hasErrors = properties.some((prop) => prop.plus_price_error);

  if (hasErrors || !properties?.length) {
    return {
      totalForestArea: 0,
      propertiesTotalPrice: 0,
      discountAmount: 0,
      discountedPrice: 0,
      propertiesHectarePrice: 0,
    };
  }

  const totalForestArea = getTotalForestArea(properties);

  let propertiesTotalPrice = 0
  let MultiPlusDiscount = undefined
  //Ugly fix to show 15% discount for multiple properties or already has DFR
  if (hasDfr) {
  // prop.plus_price is already 85% from backend 
  const originalTotal = properties.reduce(
    (acum, prop) => acum + (prop.plus_price / 0.85), 0
  );

  propertiesTotalPrice = properties.reduce((acum, prop) => acum + prop.plus_price, 0);
  const multiPlusDiscountAmount = originalTotal - propertiesTotalPrice;

  MultiPlusDiscount = {
    "discountAmount": multiPlusDiscountAmount,
    "discountReason": "Rabatt som Plusmedlem (15%)"
  };

} else if (properties.length > 1 && !hasDfr) {
  // prop.plus_price is 100%
  propertiesTotalPrice = properties.reduce(
    (acum, prop) => acum + (prop.plus_price * 0.85), 0
  );

  const multiPlusDiscountAmount = properties.reduce(
    (acum, prop) => acum + (prop.plus_price * 0.15), 0
  );

  MultiPlusDiscount = {
    "discountAmount": multiPlusDiscountAmount,
    "discountReason": "Rabatt vid köp av flera fastigheter (15%)"
  };
}else {
    propertiesTotalPrice = properties.reduce(
      (acum, prop) => acum + prop.plus_price,
      0
    );
  }

  const propertiesHectarePrice = propertiesTotalPrice / totalForestArea ?? 0;

  const discountAmount = calculateDiscountAmount(couponDiscount);
  const discountedPrice = Math.max(propertiesTotalPrice - discountAmount, 0);

  return {
    totalForestArea,
    propertiesTotalPrice: propertiesTotalPrice,
    discountAmount,
    discountedPrice,
    propertiesHectarePrice,
    MultiPlusDiscount
  };
};
